import {
  ApprovalState,
  ReportType,
} from '../../../../../api/api-clientInformation';

export const approvalFlowConfig: Partial<Record<ReportType, string[]>> = {
  [ReportType.AnomalyReport]: [
    'areaLeadInspEng',
    'inspEngSupervisor',
    'informedEmailsTo',
    'informedEmailsCc'

  ],
  [ReportType.TaskDeferral]: [
    'areaLeadInspEng',
    'inspEngSupervisor',
    'srOpsConsultant',
    // 'LocalTechnicalAuthority',
    // 'assetTypeHCEPO',
    // 'areaOpsSuperintendent',
    // 'productionOperationManager',
    // 'generalManagerOperation',
    // 'generalDirector',
    'informedEmailsTo',
    'informedEmailsCc',
  ],
  [ReportType.IntegrityThreat]: [
    'areaLeadInspEng',
    'inspEngSupervisor',
    'srOpsConsultant',
    // 'assetTypeHCEPO',
    // 'areaOpsSuperintendent',
    'informedEmailsTo',
    'informedEmailsCc',
  ],
  [ReportType.ReliabilityThreat]: [
    'areaLeadInspEng',
    'inspEngSupervisor',
    'srOpsConsultant',
    // 'assetTypeHCEPO',
    // 'areaOpsSuperintendent',
    'informedEmailsTo',
    'informedEmailsCc'
  ],
  [ReportType.ReliabilityDeficiency]: [
    'areaLeadInspEng',
    'inspEngSupervisor',
    'srOpsConsultant',
    // 'LocalTechnicalAuthority',
    // 'assetTypeHCEPO',
    // 'areaOpsSuperintendent',
    // 'productionOperationManager',
    // 'generalManagerOperation',
    // 'generalDirector',
    'informedEmailsTo',
    'informedEmailsCc'
  ],
  [ReportType.IntegrityDeficiency]: [
    'areaLeadInspEng',
    'inspEngSupervisor',
    'srOpsConsultant',
    // 'LocalTechnicalAuthority',
    // 'assetTypeHCEPO',
    // 'areaOpsSuperintendent',
    // 'productionOperationManager',
    // 'generalManagerOperation',
    // 'generalDirector',
    'informedEmailsTo',
    'informedEmailsCc'
  ],

};

export const fdmStepStatusConfig: Partial<Record<ReportType, string[]>> = {
  [ReportType.AnomalyReport]: [
    'Draft',
    'Reviewing',
    'Plan Confirmed',
    'RIPT Scored',
    'Plan Approved',
    'Resolution Plan Completed',
    'V&V Completed',
    'Closed',
  ],
  [ReportType.TaskDeferral]: [
    'Draft',
    'Reviewing',
    'Plan Confirmed',
    'Risk Scored',
    'Plan Endorsed',
    'Plan Approved',
    'Resolution Plan Completed',
    'V&V Completed',
    'Closed',
  ],
  [ReportType.IntegrityThreat]: [
    'Draft',
    'Reviewing',
    'Submitted to Sr Ops',
    'Plan Confirmed',
    'RIPT Scored',
    'Plan Endorsed',
    'Plan Approved',
    'Resolution Plan Completed',
    'V&V Completed',
    'Closed',
  ],
  [ReportType.ReliabilityThreat]: [
    'Draft',
    'Reviewing',
    'Submitted to Sr Ops',
    'Plan Confirmed',
    'RIPT Scored',
    'Plan Endorsed',
    'Plan Approved',
    'Resolution Plan Completed',
    'V&V Completed',
    'Closed',
  ],
  [ReportType.ReliabilityDeficiency]: [
    'Draft',
    'Reviewing',
    'Submitted to Sr Ops',
    'Risk Scored',
    'Plan Confirmed',
    'RIPT Scored',
    'Plan Endorsed',
    'Plan Approved',
    'Resolution Plan Completed',
    'V&V Completed',
    'Closed',
  ],
  [ReportType.IntegrityDeficiency]: [
    'Draft',
    'Reviewing',
    'Submitted to Sr Ops',
    'Risk Scored',
    'Plan Confirmed',
    'RIPT Scored',
    'Plan Endorsed',
    'Plan Approved',
    'Resolution Plan Completed',
    'V&V Completed',
    'Closed',
  ],
};

export const fdmStepStatusConfig2: Partial<
  Record<ReportType, ApprovalState[]>
> = {
  [ReportType.AnomalyReport]: [
    ApprovalState.Draft,
    ApprovalState.DraftedForReview,
    ApprovalState.PlanConfirmed,
    ApprovalState.RIPTScored,
    // ApprovalState.RIPTSkipped,
    ApprovalState.PlanApproved,
    ApprovalState.ResolutionPlanCompleted,
    ApprovalState.ValidationAndVerificationCompleted,
    ApprovalState.Closed,
  ],
  [ReportType.TaskDeferral]: [
    ApprovalState.Draft,
    ApprovalState.DraftedForReview,
    ApprovalState.SubmittedToOpsAdvisor,
    ApprovalState.RiskEvaluationScored,
    ApprovalState.PlanConfirmed,
    ApprovalState.PlanEndorsed,
    ApprovalState.PlanApproved,
    ApprovalState.ResolutionPlanCompleted,
    // ApprovalState.ValidationAndVerificationCompleted,
    ApprovalState.Closed,
  ],
  [ReportType.IntegrityThreat]: [
    ApprovalState.Draft,
    ApprovalState.DraftedForReview,
    ApprovalState.SubmittedToOpsAdvisor,
    ApprovalState.PlanConfirmed,
    ApprovalState.RIPTScored,
    ApprovalState.PlanEndorsed,
    ApprovalState.PlanApproved,
    ApprovalState.ResolutionPlanCompleted,
    ApprovalState.ValidationAndVerificationCompleted,
    ApprovalState.Closed,
  ],
  [ReportType.ReliabilityThreat]: [
    ApprovalState.Draft,
    ApprovalState.DraftedForReview,
    ApprovalState.SubmittedToOpsAdvisor,
    ApprovalState.PlanConfirmed,
    ApprovalState.RIPTScored,
    ApprovalState.PlanEndorsed,
    ApprovalState.PlanApproved,
    ApprovalState.ResolutionPlanCompleted,
    ApprovalState.ValidationAndVerificationCompleted,
    ApprovalState.Closed,
  ],
  [ReportType.ReliabilityDeficiency]: [
    ApprovalState.Draft,
    ApprovalState.DraftedForReview,
    ApprovalState.SubmittedToOpsAdvisor,
    ApprovalState.RiskEvaluationScored,
    ApprovalState.PlanConfirmed,
    ApprovalState.RIPTScored,
    ApprovalState.PlanEndorsed,
    ApprovalState.PlanApproved,
    ApprovalState.ResolutionPlanCompleted,
    ApprovalState.ValidationAndVerificationCompleted,
    ApprovalState.Closed,
  ],
  [ReportType.IntegrityDeficiency]: [
    ApprovalState.Draft,
    ApprovalState.DraftedForReview,
    ApprovalState.SubmittedToOpsAdvisor,
    ApprovalState.RiskEvaluationScored,
    ApprovalState.PlanConfirmed,
    ApprovalState.RIPTScored,
    ApprovalState.PlanEndorsed,
    ApprovalState.PlanApproved,
    ApprovalState.ResolutionPlanCompleted,
    ApprovalState.ValidationAndVerificationCompleted,
    ApprovalState.Closed,
  ],
};
